export class SupportInformation {
    partnerServicesPhone: string = "";
    partnerServicesLabel: string = "";
    supportEmail: string = "";
    issuesPortalUrl: string = "";
}
